export default __webpack_public_path__ + "static/media/carlo.fb2dd2b4.png";